export default __webpack_public_path__ + "static/media/services_cree.679516c7.svg";